import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const user = {
  state: {
    token: storage.get(ACCESS_TOKEN) || '',
    userInfo: storage.get('userInfo') || {}
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    }
  },

  actions: {
    // Login
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        storage.set(ACCESS_TOKEN, userInfo.token)
        storage.set('userInfo', userInfo)
        commit('SET_TOKEN', userInfo.token)
        commit('SET_USER_INFO', userInfo)
        resolve()
      })
    },

    // Get User Info
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        // TODO: Implement actual getInfo API call
        resolve()
      })
    },

    // Logout
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', {})
        storage.remove(ACCESS_TOKEN)
        storage.remove('userInfo')
        resolve()
      })
    }
  }
}

export default user
